import React, { useContext } from 'react';
import gift from "../../images/present4.jpg";
import AppState from '../../context/AppContext'


function ListChildAndGifts( ) {
    const context = useContext(AppState)
    return (
        <div>
            <h1>LetterToSanta</h1>
            <h1 className="my-5">
                <u>Parent Mode</u>
            </h1>
            <div className="row">
                <div className="col d-flex flex-column aling-items-center justify-content-center">
                    {
                        context.store.children.map(child => {
                            if (child.name === context.store.currentChildName) {
                                return (
                                    <div key={child.uid} className="row row-cols-1">
                                        <h2>{child.name}</h2>
                                        <h3>Potential presets:</h3>
                                        <ul>
                                            {child.list.map((gift, i) => (
                                                <li key={i}>{gift}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                            }
                       return undefined })
                    }
                </div>
                <div className="col">
                    <img
                        className="santa"
                        src={gift}
                        alt="santa"
                    />
                </div>
            </div>
        </div>
    );
}

export default ListChildAndGifts;
